import { createPortal } from 'react-dom';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/shared/ui/Button/Button';
import styles from './VersaoAppBloqueio.module.css';

export type VersaoAppBloqueioProps = {
  open: boolean;
  mensagem?: string;
};

/**
 * Overlay bloqueante para 426 VERSAO_APP_DESATUALIZADA.
 * Nao tem botao de fechar — o usuario precisa atualizar o cliente.
 */
export function VersaoAppBloqueio({ open, mensagem }: VersaoAppBloqueioProps) {
  if (!open) return null;

  const storeUrl = (import.meta.env.VITE_STORE_URL as string | undefined)?.trim() ?? '';

  return createPortal(
    <div className={styles.overlay} role="alertdialog" aria-modal="true" aria-labelledby="versao-bloqueio-title">
      <div className={styles.card}>
        <RefreshCw size={40} className={styles.icon} aria-hidden />
        <h2 id="versao-bloqueio-title" className={styles.title}>
          Atualizacao obrigatoria
        </h2>
        <p className={styles.body}>
          {mensagem?.trim() || 'Atualize o aplicativo para continuar.'}
        </p>
        {storeUrl ? (
          <Button
            variant="primary"
            size="lg"
            fullWidth
            onClick={() => {
              window.location.assign(storeUrl);
            }}
          >
            Atualizar agora
          </Button>
        ) : null}
      </div>
    </div>,
    document.body,
  );
}
